import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Loading } from '@orobix/orobix-fe-components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { downloadWarningTreshold } from './const'
import { fetchCounter } from './utils'

const downloadIcon = <FontAwesomeIcon icon={faCloudDownloadAlt} />

const loadingIcon = <Loading />

type DownloadButtonProps = {
  canDownload: boolean
  isDemo: boolean
  showPrecisionAlertModal: () => void
  onDirectDownload: () => void
  onRequiresConfirmation: () => void
}

const DownloadButton = ({
  canDownload,
  onDirectDownload,
  onRequiresConfirmation,
  isDemo,
  showPrecisionAlertModal,
}: DownloadButtonProps) => {
  const { t } = useTranslation()
  const [isFetching, setFetching] = useState(false)

  const handleClick = async () => {
    if (canDownload) {
      setFetching(true)
      const counter = await fetchCounter()
      setFetching(false)

      if (counter) {
        const usageOk =
          counter.currentValue / counter.threshold < downloadWarningTreshold
        const skipConfirmation = !counter.isEnabled || usageOk

        if (skipConfirmation) {
          onDirectDownload()
        } else {
          onRequiresConfirmation()
        }
      }
    }
  }

  const getTitle = (_canDownload: boolean, _isDemo: boolean) => {
    if (!_canDownload && _isDemo) {
      return t(
        `You can't download the model trained with a backbone demo version`
      )
    }
    if (!_canDownload) {
      return t(
        `You can't download the trained model with the current version of the software`
      )
    }
    return undefined
  }

  return (
    <Button
      onClick={(e) => {
        e.stopPropagation()
        showPrecisionAlertModal()
        handleClick()
      }}
      hideLabel
      icon={isFetching ? loadingIcon : downloadIcon}
      label={t('Download')}
      buttonType="button"
      type="blank-default"
      size="sm"
      disabled={!canDownload}
      title={getTitle(canDownload, isDemo)}
    />
  )
}

export default DownloadButton
